import { useTranslation } from 'react-i18next';
import { useModalContext } from '../../contexts/ModalContext';
import AppModal from './Modal';

const ModalMessage = () => {
    const { t } = useTranslation();

    const { modalMessage, setModalMessage } = useModalContext();

    const close = () => {
        setModalMessage(null);
    };

    if (!modalMessage) return <></>;

    return (
        <AppModal
            safeAction={close}
            safeText={t('button.close') as string}
        >
            <p>{modalMessage}</p>
        </AppModal>
    );
};

export default ModalMessage;
